import React, { useState } from "react";
import api from "../api/api";

export default function FileUpload({ folderId, onUpload }) {
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);

  const handleUpload = async () => {
    if (files.length === 0) return;
    setUploading(true);
    let completed = 0;

    try {
      const promises = files.map(async (file) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("name", file.name);
        formData.append("folder", folderId);

        await api.post("files/", formData, {
          onUploadProgress: (e) => {
            const current = (e.loaded / e.total);
            setProgress(Math.round(((completed + current) / files.length) * 100));
          }
        });
        completed++;
      });

      await Promise.all(promises);
      setFiles([]);
      if (onUpload) onUpload();
      alert("Sucesso!");
    } catch (err) { alert("Erro no upload ou ficheiro ja existe."); }
    finally { setUploading(false); setProgress(0); }
  };

  return (
    <div className="file-upload-box">
      <h4>Subir Ficheiros</h4>
      <input type="file" multiple onChange={e => setFiles(Array.from(e.target.files))} disabled={uploading} />
      <button className="btn save-btn" onClick={handleUpload} disabled={uploading || files.length === 0}>
        {uploading ? `Enviando ${progress}%` : `Enviar ${files.length} ficheiros`}
      </button>
      {uploading && <div className="progress-container"><div className="progress-bar" style={{width: `${progress}%`}}></div></div>}
    </div>
  );
}